import { deepCopySportAggs } from './deepCopySportAggs';
import { deepCopyAggs } from './deepCopyAggs';
import { deepCopyBetGroup } from './deepCopyBetGroup';

export function getPrematchAggs(sportId = null, aggId = null) {
    const aggsList = window.xs_ag.aggregatePrematchBySportId;
    if (sportId == null && aggId == null) {
        return deepCopySportAggs(aggsList);
    } else if (aggId == null) {
        return deepCopyAggs(aggsList[sportId]);
    } else {
        const agg = aggsList[sportId][aggId];
        return agg != null ? deepCopyBetGroup(agg): null;
    }
}
